import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Store } from '@ngrx/store';

import { SetOrderGuest } from '../store/order-status.actions';

@Injectable()
// eslint-disable-next-line deprecation/deprecation
export class OrderStatusResolver implements Resolve<void> {
    constructor(private readonly store: Store) {}

    public resolve(route: ActivatedRouteSnapshot): void {
        if (!!route.queryParams?.guestToken && !!route.queryParams?.orderId) {
            this.store.dispatch(SetOrderGuest({
                orderId: route.queryParams?.orderId,
                guestId: decodeURI(route.queryParams?.guestToken),
            }));
        }
    }
}
